import { RouterEffects } from "./router.effects";

export const effects: any[] = [RouterEffects];

export * from "./router.effects";
